// import '@scripts/carousel/classes/3DCarousel.js';
import { ImageCarousel } from '@scripts/carousel/classes/ImageCarousel.js';

function initCarousels () {
    document.querySelectorAll('.image-carousel').forEach(function (el) {
        new ImageCarousel(el);
    });
}

window.addEventListener('DOMContentLoaded', initCarousels);
